import React, { useState, useEffect } from "react";
import "../../assets/css/GameDevelopment.css";
import img2 from "../../assets/image/GameDevelopImage/ui-ux.jpg";
import img3 from "../../assets/image/GameDevelopImage/Action.png";
import img4 from "../../assets/image/GameDevelopImage/Service image 1.jpeg";
import img5 from "../../assets/image/GameDevelopImage/Service image2.jpeg";
import img6 from "../../assets/image/GameDevelopImage/Service Image3.jpeg";
import img7 from "../../assets/image/GameDevelopImage/Service Image4.jpeg";
import img8 from "../../assets/image/GameDevelopImage/Service Image5.jpeg";
import img9 from "../../assets/image/GameDevelopImage/Service Image6.jpeg";
import img10 from "../../assets/image/GameDevelopImage/Service Image7.jpeg";
import img11 from "../../assets/image/GameDevelopImage/Service Image8jpeg.jpeg";
import img12 from "../../assets/image/GameDevelopImage/Service Image9.jpeg";
import img13 from "../../assets/image/GameDevelopImage/Service Image10.jpeg";
import img14 from "../../assets/image/GameDevelopImage/Service Image11.png";
import img17 from "../../assets/image/GameDevelopImage/Service Image14.jpeg";
import img18 from "../../assets/image/GameDevelopImage/Service Image.png";
import Footer from "../Footer/Footer";
import gameOne from "../../assets/image/GameDevelopImage/gameIcon-1.png";
import gameTwo from "../../assets/image/GameDevelopImage/gameIcon-2.png";
import gameThree from "../../assets/image/GameDevelopImage/gameIcon-3.png";
import gameFour from "../../assets/image/GameDevelopImage/gameIcon-4.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import data from "../../Meta/Meta_ApiUrl";

const GameDevelopment = () => {
  const [meta, setMeta] = useState({});

  useEffect(() => {
    const Gamedevelopment = data[0]?.services_page_Gamedevelopment;

    if (Gamedevelopment) {
      setMeta(Gamedevelopment);
    }
  }, []);
  const [activeTab, setActiveTab] = useState("mobile");
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      mirror: false,
    });
  }, []);

  const gameTypes = [
    {
      id: "mobile",
      title: "Mobile Games",
      games: [
        {
          name: "Puzzle Adventure",
          genre: "Puzzle",
          image: img8,
          content:
            "Puzzle Adventure is an exciting journey filled with brain-teasing challenges and hidden mysteries, Each level tests your logic and creativity as you unlock clues and explore unknown realms.",
        },
        {
          name: "Racing Thunder",
          genre: "Racing",
          image: img9,
          content:
            "Racing Thunder is a fast-paced 3D racing game where you race powerful cars on thrilling tracks, use nitro boosts, and compete for the top spot.",
        },
        {
          name: "Battle Royale",
          genre: "Action",
          image: img10,
          content:
            "Battle Royale is a survival shooter game where players fight to be the last one standing on a shrinking battlefield, using strategy, weapons, and quick reflexes to win.",
        },
      ],
    },
    {
      id: "pcappi",
      title: "PC Games",
      games: [
        {
          name: "Fantasy RPG",
          genre: "RPG",
          image: img5,
          content:
            "Fantasy RPG is a role-playing game set in a magical world where players complete quests, battle mythical creatures, and level up their hero with powerful gear and skills.",
        },
        {
          name: "Space Simulator",
          genre: "Simulation",
          image: img6,
          content:
            "Space Simulator is a realistic game where players explore the universe, pilot spacecraft, and experience space missions with accurate physics and stunning visuals.",
        },
        {
          name: "Strategy Empire",
          genre: "Strategy",
          image: img7,
          content:
            "Strategy Empire is a tactical game where players build kingdoms, manage resources, train armies, and conquer enemies to expand their empire and rule the land.",
        },
      ],
    },
    {
      id: "console",
      title: "Console Games",
      games: [
        {
          name: "Action Hero",
          genre: "Action-Adventure",
          image: img3,
          content:
            "Action Hero is a high-energy game where players take on daring missions, battle enemies with powerful weapons, and unleash heroic moves to save the day.",
        },
        {
          name: "Sports Championship",
          genre: "Sports",
          image: img4,
          content:
            "Sports Championship is a competitive game where players take part in various sports events, showcase their skills, and strive to win trophies and become champions.",
        },
        {
          name: "Platformer Quest",
          genre: "Platformer",
          image: img5,
          content:
            "Platformer Quest is a fun adventure game where players jump, run, and solve puzzles across vibrant levels to complete missions and defeat enemies.",
        },
      ],
    },
  ];

  return (
    <HelmetProvider>
      <div style={{ overflowX: "hidden" }}>
        <Helmet>
          <title>
            {meta?.title || "Services-Gamedevelopment - SHIV NEXTGEN TECHNOLOGIES PRIVATE LIMITED"}
          </title>
          <meta
            name="description"
            content={meta?.meta?.meta1?.content || "Our curriculum."}
          />
        </Helmet>
        <div
          className="game-bg position-relative overflow-hidden min-vh-50 d-flex align-items-center"
          data-aos="fade-up"
        >
          <div className="position-absolute top-0 start-0 w-100 h-100 opacity-20"></div>
          <div className="container position-relative">
            <div className="row align-items-center">
              <div className="col-lg-6 game-content">
                <nav
                  aria-label="breadcrumb"
                  className="mb-4"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a
                        href="/"
                        className="text-white fw-bold text-decoration-none"
                      >
                        Home
                      </a>
                    </li>
                    <li
                      className="text-white fw-bold breadcrumb-item"
                      aria-current="page"
                    >
                      Game Development
                    </li>
                  </ol>
                </nav>
                <h3
                  className="display-gart fw-bold mb-3"
                  data-aos="fade-right"
                  data-aos-delay="200"
                >
                  Game Development
                </h3>
              </div>
            </div>
          </div>
        </div>

        {/* Game Portfolio Section */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h3 className="display-5 fw-bold font-black mb-2">
                Our Game <span className="font-red">Development</span>
              </h3>
              <p className="font-para mb-4">
                Explore our diverse range of successful games across different
                platforms
              </p>

              <div
                className="d-flex flex-wrap justify-content-center gap-2 mb-4"
                role="group"
                data-aos="fade-up"
                data-aos-delay="100"
              >
                {gameTypes.map((type) => (
                  <button
                    key={type.id}
                    className={`btn fw-bold fs-6 custom-tab-btn ${
                      activeTab === type.id
                        ? "btn-dark text-white"
                        : "btn-outline-danger"
                    } px-3 px-sm-4 py-2`}
                    onClick={() => setActiveTab(type.id)}
                  >
                    {type.title}
                  </button>
                ))}
              </div>
            </div>

            {gameTypes.map((type) => (
              <div
                key={type.id}
                className={`${activeTab === type.id ? "d-block" : "d-none"}`}
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div className="text-center mb-5">
                  <p className="font-black fw-semibold mb-4 fs-5">
                    {type.description}
                  </p>
                </div>
                <div className="row g-4">
                  {type.games.map((game, index) => (
                    <div
                      key={index}
                      className="col-12 col-md-6 col-lg-4"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <div className="card border-0 shadow-lg hover-lift h-100">
                        <div className="position-relative overflow-hidden rounded-top">
                          <img
                            src={game.image}
                            className="card-img-top hover-scale img-fluid"
                            alt={game.name}
                            style={{
                              width: "100%",
                              height: "200px",
                              objectFit: "cover",
                            }}
                          />
                          <div className="position-absolute top-0 end-0 m-3">
                            <span
                              className="rounded px-2 py-1"
                              style={{
                                backgroundColor: "#41C1EE",
                                color: "#ffffff",
                              }}
                            >
                              {game.genre}
                            </span>
                          </div>
                        </div>
                        <div className="card-body p-4 d-flex flex-column justify-content-between">
                          <div>
                            <h4 className="font-card-heading fw-bold mb-3">
                              {game.name}
                            </h4>
                            <p className="font-card-para fw-medium mb-4">
                              {game.content}
                            </p>
                          </div>
                          <div className="d-flex justify-content-between align-items-center mt-auto pt-2">
                            <button
                              className="btn fw-semibold px-3 py-2 bg-red"
                              style={{
                                color: "#ffffff",
                              }}
                            >
                              Learn More
                            </button>
                            <div className="d-flex align-items-center gap-1">
                              <i
                                className="fas fa-star"
                                style={{ color: "#ffe234" }}
                              ></i>
                              <span className="fw-semibold fs-6">4.8</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* Technology Stack */}
        <section className="py-5 bg-white">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h3 className="display-5 fw-bold font-black mb-2">
                Advanced <span className="font-red">Technology </span> Stack
              </h3>
              <p className="font-para">
                Powered by industry-leading engines and frameworks
              </p>
            </div>

            <div className="row g-4 mb-5">
              {/* 3D - Games */}
              <div
                className="col-lg-6"
                data-aos="fade-right"
                data-aos-delay="100"
              >
                <div className="card border-0 shadow-lg h-100 bg-white font-black">
                  <div className="card-body p-4 p-sm-5">
                    <div className="d-flex align-items-center mb-4">
                      <div className="bg-white bg-opacity-20 rounded-3 p-3 me-4">
                        <i className="fas fa-cube fs-1 font-red"></i>
                      </div>
                      <div>
                        <h4 className="font-card-heading fw-bold mb-1">
                          3D Game Engines
                        </h4>
                        <p className="font-para">
                          Next-gen graphics and physics
                        </p>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div
                        className="col-6"
                        data-aos="fade-up"
                        data-aos-delay="200"
                      >
                        <div className="bg-white bg-opacity-10 rounded-3 p-3 text-center">
                          <i className="fab fa-unity fs-2 mb-2"></i>
                          <h5 className="font-card-heading fw-bold">
                            Unity 3D
                          </h5>
                          <small className="fw-medium fs-6">
                            Cross-platform development
                          </small>
                        </div>
                      </div>
                      <div
                        className="col-6"
                        data-aos="fade-up"
                        data-aos-delay="300"
                      >
                        <div className="bg-white bg-opacity-10 rounded-3 p-3 text-center">
                          <i className="fas fa-rocket fs-2 mb-2"></i>
                          <h5 className="font-card-heading fw-bold">
                            Unreal Engine
                          </h5>
                          <small className="fw-medium fs-6">
                            AAA game quality
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2D - Games */}
              <div
                className="col-lg-6"
                data-aos="fade-left"
                data-aos-delay="100"
              >
                <div className="card border-0 shadow-lg h-100 bg-white font-black">
                  <div className="card-body p-4 p-sm-5">
                    <div className="d-flex align-items-center mb-4">
                      <div className="bg-white bg-opacity-20 rounded-3 p-3 me-4">
                        <i className="fas fa-layer-group fs-1 font-red"></i>
                      </div>
                      <div>
                        <h3 className="font-card-heading fw-bold mb-1">
                          2D Frameworks
                        </h3>
                        <p className="mb-0 font-para">
                          Optimized for performance
                        </p>
                      </div>
                    </div>
                    <div className="row g-3">
                      <div
                        className="col-12 col-md-6"
                        data-aos="fade-left"
                        data-aos-delay="200"
                      >
                        <div className="bg-white bg-opacity-10 rounded-3 p-3 text-center">
                          <i className="fas fa-gamepad fs-2 mb-2"></i>
                          <h5 className="font-card-heading fw-bold">
                            Cocos2d-x
                          </h5>
                          <small className="fw-medium fs-6">
                            Multi-platform 2D
                          </small>
                        </div>
                      </div>
                      <div
                        className="col-12 col-md-6"
                        data-aos="fade-up"
                        data-aos-delay="300"
                      >
                        <div className="bg-white bg-opacity-10 rounded-3 p-3 text-center">
                          <i className="fab fa-html5 fs-2 mb-2"></i>
                          <h5 className="font-card-heading fw-bold">Phaser</h5>
                          <small className="fw-medium fs-6">HTML5 gaming</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row g-4">
              {[
                {
                  icon: gameOne,
                  title: "C++",
                  description: "High-performance engine development",
                },
                {
                  icon: gameTwo,
                  title: "C#",
                  description: "Unity and .NET game development",
                },
                {
                  icon: gameThree,
                  title: "JavaScript",
                  description: "Web-based and mobile games",
                },
                {
                  icon: gameFour,
                  title: "Python",
                  description: "AI and backend game systems",
                },
              ].map((lang, index) => (
                <div
                  key={index}
                  className="col-6 col-md-3"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="card border-0 shadow-lg h-100 text-center">
                    <div className="card-body p-4">
                      <div className="mx-auto mb-3 d-flex align-items-center justify-content-center">
                        <img
                          src={lang.icon}
                          alt={lang.title}
                          style={{
                            width: "70px",
                            height: "70px",
                            objectFit: "contain",
                          }}
                        />
                      </div>
                      <h3 className="h4 fw-bold font-black mb-3">
                        {lang.title}
                      </h3>
                      <p className="font-card-para fw-medium fs-6">
                        {lang.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Game Development Process */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h3 className="display-5 fw-bold mb-2 font-black">
                Development <span className="font-red">Process </span>
              </h3>
              <p className="font-para">
                From concept to launch, our proven methodology ensures success
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  img: img11,
                  title: "Concept & Planning",
                  description:
                    "Ideation, market research, and technical feasibility analysis to create a solid game foundation.",
                },
                {
                  img: img12,
                  title: "Design & Prototyping",
                  description:
                    "Creating detailed game design documents, wireframes, and interactive prototypes.",
                },
                {
                  img: img13,
                  title: "Development & Testing",
                  description:
                    "Agile development with continuous testing, optimization, and quality assurance.",
                },
              ].map((process, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="text-center">
                    <div className="position-relative mb-4 overflow-hidden">
                      <img
                        src={process.img}
                        alt={process.title}
                        className="img-fluid rounded-4 shadow-lg"
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <h3 className="h3 fw-bold font-red mb-3">
                      {process.title}
                    </h3>
                    <p className="font-para">{process.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Platform Coverage */}
        <section className="py-5 bg-white">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h3 className="display-5 fw-bold mb-2 font-black">
                Multi-Platform <span className="font-red">Excellence </span>
              </h3>
              <p className="font-para mb-4">
                Deploy your games across all major platforms with optimized
                performance
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  icon: "fa-mobile-alt",
                  title: "Mobile Platforms",
                  description: "iOS App Store & Google Play Store optimization",
                  icons: ["fa-playstation", "fa-xbox"],
                },
                {
                  icon: "fa-globe",
                  title: "Web Gaming",
                  description: "HTML5, WebGL & Progressive Web Apps",
                  icons: ["fa-html5", "fa-chrome"],
                },
                {
                  icon: "fa-mobile-alt",
                  title: "App Development",
                  description: "Android, iOS & Cross-platform Solutions",
                  icons: ["fa-android", "fa-apple", "fa-react"],
                },
                {
                  icon: "fa-gamepad",
                  title: "Game Development",
                  description: "Unity, Unreal Engine & Cocos2d Game Solutions",
                  icons: ["fa-unity", "fas fa-cubes", "fas fa-laptop-code"],
                },
              ].map((platform, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6 col-lg-3"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="card border-0 shadow-lg text-center hover-lift h-100">
                    <div className="card-body p-4">
                      <div
                        className="bg-red rounded-circle mx-auto mb-3 d-flex align-items-center justify-content-center"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <i
                          className={`fas ${platform.icon} text-white fs-2`}
                        ></i>
                      </div>
                      <h4 className="h4 fw-bold mb-3">{platform.title}</h4>
                      <p className="font-black fw-medium fs-6 mb-3">
                        {platform.description}
                      </p>
                      <div className="d-flex justify-content-center gap-2">
                        {platform.icons.map((icon, i) => (
                          <i
                            key={i}
                            className={`fab ${icon} fs-4 font-black`}
                          ></i>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Monetization Strategies */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-12 col-lg-6 mb-4 mb-lg-0"
                data-aos="fade-right"
              >
                <div className="w-100 px-3 px-sm-5 px-md-4 overflow-hidden">
                  <img
                    src={img14}
                    alt="Game Monetization"
                    className="img-fluid rounded-4 w-100"
                    style={{ objectFit: "cover", height: "400px" }}
                  />
                </div>
              </div>

              <div className="col-12 col-lg-6" data-aos="fade-left">
                <h3
                  className="display-6 fw-bold mb-3 font-black"
                  data-aos="fade-up"
                  data-aos-delay="100"
                >
                  Revenue <span className="font-red">Optimization</span>
                </h3>
                <p
                  className="font-para mb-4"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  Maximize your game's earning potential with strategic
                  monetization approaches that enhance rather than disrupt
                  gameplay.
                </p>

                <div className="row g-4">
                  {[
                    {
                      icon: "fa-coins",
                      title: "In-App Purchases",
                      description: "Cosmetics, power-ups, and premium content",
                    },
                    {
                      icon: "fa-ad",
                      title: "Smart Advertising",
                      description: "Rewarded ads and native integrations",
                    },
                    {
                      icon: "fa-crown",
                      title: "Premium Subscriptions",
                      description: "VIP memberships and season passes",
                    },
                    {
                      icon: "fa-chart-pie",
                      title: "Analytics Integration",
                      description: "Data-driven optimization strategies",
                    },
                  ].map((strategy, index) => (
                    <div
                      key={index}
                      className="col-12 col-md-6"
                      data-aos="fade-up"
                      data-aos-delay={index * 100 + 300}
                    >
                      <div className="d-flex align-items-start">
                        <div
                          className="bg-dark rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{ width: "50px", height: "50px" }}
                        >
                          <i className={`fas ${strategy.icon} text-white`}></i>
                        </div>
                        <div>
                          <h5 className="fw-bold font-red mb-1">
                            {strategy.title}
                          </h5>
                          <p className="font-para mb-0">
                            {strategy.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Game Art & Design */}
        <section className="py-5 bg-white">
          <div className="container">
            <div className="text-center mb-5" data-aos="fade-up">
              <h2 className="display-5 fw-bold mb-2 font-black">
                Art & <span className="font-red">Visual Design</span>
              </h2>
              <p className="font-para">
                Stunning visuals that bring your game world to life
              </p>
            </div>

            <div className="row g-4">
              {[
                {
                  img: img17,
                  title: "2D Art & Sprites",
                  description:
                    "Character design, animations, and environmental art",
                },
                {
                  img: img18,
                  title: "3D Modeling",
                  description: "High-poly characters, environments, and assets",
                },
                {
                  img: img2,
                  title: "UI/UX Design",
                  description:
                    "Intuitive interfaces and user experience design",
                },
              ].map((art, index) => (
                <div
                  key={index}
                  className="col-12 col-md-6 col-lg-4"
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <div className="position-relative overflow-hidden rounded-4 shadow-lg">
                    <img
                      src={art.img}
                      alt={art.title}
                      className="img-fluid hover-scale w-100"
                      style={{ height: "270px", objectFit: "cover" }}
                    />
                    <div className="position-absolute bottom-0 start-0 w-100 bg-gradient-dark text-white p-4">
                      <h4 className="h4 fw-bold mb-2">{art.title}</h4>
                      <p className="mb-0 small">{art.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Game Testing & QA */}
        <section className="py-5 bg-light">
          <div className="container">
            <div className="row align-items-center">
              <div
                className="col-12 col-lg-6 mb-5 mb-lg-0"
                data-aos="fade-right"
              >
                <h3 className="display-5 fw-bold mb-3 font-black">
                  Quality Assurance & <span className="font-red">Testing</span>
                </h3>
                <p className="font-para mb-4">
                  Comprehensive testing ensures your game delivers a flawless
                  experience across all platforms and devices.
                </p>

                {/* QA CARDS */}
                <div className="row g-4">
                  {[
                    {
                      icon: "fa-bug",
                      title: "Bug Testing & Debugging",
                      description:
                        "Systematic identification and resolution of gameplay issues and technical bugs.",
                    },
                    {
                      icon: "fa-tachometer-alt",
                      title: "Performance Optimization",
                      description:
                        "Frame rate optimization, memory management, and loading time improvements.",
                    },
                    {
                      icon: "fa-users",
                      title: "User Acceptance Testing",
                      description:
                        "Real player feedback and usability testing to refine gameplay mechanics.",
                    },
                  ].map((qa, index) => (
                    <div
                      key={index}
                      className="col-12"
                      data-aos="fade-up"
                      data-aos-delay={index * 100}
                    >
                      <div className="card border-0 shadow-sm h-100">
                        <div className="card-body p-4">
                          <div className="d-flex align-items-center mb-3">
                            <i
                              className={`fas ${qa.icon} font-red fs-3 me-3`}
                            ></i>
                            <h4 className="h5 fw-bold mb-0">{qa.title}</h4>
                          </div>
                          <p className="font-para mb-0">{qa.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* IMAGE GRID */}
              <div className="col-12 col-lg-6 mt-1" data-aos="fade-left">
                <div className="row g-3">
                  <div
                    className="col-6"
                    data-aos="fade-up"
                    data-aos-delay="100"
                  >
                    <img
                      src={img13}
                      alt="Game Testing"
                      className="img-fluid rounded-4 shadow-lg w-100"
                      style={{ objectFit: "cover", height: "200px" }}
                    />
                  </div>
                  <div
                    className="col-6"
                    data-aos="fade-up"
                    data-aos-delay="200"
                  >
                    <img
                      src={img12}
                      alt="Quality Assurance"
                      className="img-fluid rounded-4 shadow-lg w-100"
                      style={{ objectFit: "cover", height: "200px" }}
                    />
                  </div>
                  <div
                    className="col-12"
                    data-aos="fade-up"
                    data-aos-delay="300"
                  >
                    <img
                      src={img11}
                      alt="Game Development Team"
                      className="img-fluid rounded-4 shadow-lg w-100"
                      style={{ objectFit: "cover", height: "200px" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Custom Styles */}
        <style>{`
          .hover-scale {
            transition: transform 0.3s ease;
          }
          .hover-scale:hover {
            transform: scale(1.05);
          }

          .hover-lift {
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }
          .hover-lift:hover {
            transform: translateY(-10px);
            box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15) !important;
          }

          .hover-opacity-100:hover {
            opacity: 1 !important;
          }

          .bg-gradient-primary {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          .bg-gradient-success {
            background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
          }

          .bg-gradient-dark {
            background: linear-gradient(
              0deg,
              rgba(0, 0, 0, 0.8) 0%,
              rgba(0, 0, 0, 0.3) 70%,
              transparent 100%
            );
          }

          .card {
            transition: all 0.3s ease;
            overflow: hidden;
          }

          .opacity-100 {
            opacity: 1;
          }

          .opacity-0 {
            opacity: 0;
          }

          .breadcrumb-item + .breadcrumb-item::before {
            content: "›";
            color: rgba(255, 255, 255, 0.6);
          }

          .btn {
            transition: all 0.3s ease;
          }

          .btn:hover {
            transform: translateY(-2px);
          }

          .accordion-button:not(.collapsed) {
            background-color: rgba(13, 110, 253, 0.1);
            border-color: rgba(13, 110, 253, 0.25);
          }

          @media (max-width: 768px) {
            .game-bg {
              min-height: 300px !important;
              padding-top: 80px;
              padding-bottom: 80px;
            }

            .display-gart,
            .display-5,
            .display-6 {
              font-size: 2rem !important;
            }

            .font-para {
              font-size: 0.9rem !important;
            }

            .card-body {
              padding: 1.5rem !important;
            }

            .btn {
              padding: 0.5rem 1rem !important;
              font-size: 0.9rem !important;
            }

            .section-py {
              padding-top: 3rem !important;
              padding-bottom: 3rem !important;
            }
          }

          @media (max-width: 576px) {
            .game-bg {
              min-height: 250px !important;
            }

            .display-gart,
            .display-5 {
              font-size: 1.75rem !important;
            }

            .breadcrumb {
              font-size: 0.8rem !important;
            }

            .card {
              margin-bottom: 1rem !important;
            }

            .game-content {
              text-align: center;
            }

            .game-bg .row {
              justify-content: center;
            }
          }
        `}</style>
        <Footer />
      </div>
    </HelmetProvider>
  );
};

export default GameDevelopment;
